import { keyframes } from '@chakra-ui/react';

export const KF_BLINK = keyframes`
  0% { opacity: 1; color: red; }
  50% { opacity: 0; color: currentcolor; }
  100% { opacity: 1; }
`;
